import '../../css/common.scss';
import { getRequired, createDiv } from '../core/domMan';
import controlPanelCctr, { wrapperName as controlPanelWrapperId } from '../composite/ControlPanel';
import messageBannerCctr from '../components/messageBanner';
export const wrapperName = 'mainMapWrapper';
export const identifier = 'mainMap';
export const mapContainerId = 'mapContainer';
export default (owner) => {
    let result = {};
    let mainMap = result.mainMap = document.getElementById(identifier); 
    if (mainMap) {
        result.controlPanel = controlPanelCctr();
        result.banner = messageBannerCctr();
        result.mapContainer = getRequired(mapContainerId);
    }
    else {
        owner = owner ?? getRequired(wrapperName);
        result.mainMap = mainMap = createDiv(owner, { id: identifier, className: 'mapArea' });
        result.banner = messageBannerCctr(owner);
        result.mapContainer = createDiv(mainMap, { id: mapContainerId, className: 'mapContainer' })
        const controlPanelWrapper = createDiv(mainMap, { id: controlPanelWrapperId });
        result.controlPanel = controlPanelCctr(controlPanelWrapper);
    }

    return result;
}